import 'whatwg-fetch';
import 'leaflet/dist/leaflet.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import KarteStore, { hydrate } from './store';
import App from './App';

const karteStore = new KarteStore();

hydrate('karte', karteStore).then(() => {
  karteStore.getKarteTemplate();
  ReactDOM.render(
    <Provider karte={karteStore}>
      <App />
    </Provider>,
    document.getElementById('root')
  );
});
